const LogoutIcon = ({ width = 16, height = 16 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <mask
      id="mask0_1042_36494"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16">
      <rect width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1042_36494)">
      <path
        d="M3.33333 14C2.96667 14 2.65278 13.8694 2.39167 13.6083C2.13056 13.3472 2 13.0333 2 12.6667V3.33333C2 2.96667 2.13056 2.65278 2.39167 2.39167C2.65278 2.13056 2.96667 2 3.33333 2H7.33333C7.52222 2 7.68056 2.06389 7.80833 2.19167C7.93611 2.31944 8 2.47778 8 2.66667C8 2.85556 7.93611 3.01389 7.80833 3.14167C7.68056 3.26944 7.52222 3.33333 7.33333 3.33333H3.33333V12.6667H7.33333C7.52222 12.6667 7.68056 12.7306 7.80833 12.8583C7.93611 12.9861 8 13.1444 8 13.3333C8 13.5222 7.93611 13.6806 7.80833 13.8083C7.68056 13.9361 7.52222 14 7.33333 14H3.33333ZM11.45 8.66667H6.66667C6.47778 8.66667 6.31944 8.60278 6.19167 8.475C6.06389 8.34722 6 8.18889 6 8C6 7.81111 6.06389 7.65278 6.19167 7.525C6.31944 7.39722 6.47778 7.33333 6.66667 7.33333H11.45L10.2 6.08333C10.0778 5.96111 10.0167 5.81111 10.0167 5.63333C10.0167 5.45556 10.0778 5.3 10.2 5.16667C10.3222 5.03333 10.4778 4.96389 10.6667 4.95833C10.8556 4.95278 11.0167 5.01667 11.15 5.15L13.5333 7.53333C13.6667 7.66667 13.7333 7.82222 13.7333 8C13.7333 8.17778 13.6667 8.33333 13.5333 8.46667L11.15 10.85C11.0167 10.9833 10.8583 11.0472 10.675 11.0417C10.4917 11.0361 10.3333 10.9667 10.2 10.8333C10.0778 10.7 10.0194 10.5417 10.025 10.3583C10.0306 10.175 10.0944 10.0222 10.2167 9.9L11.45 8.66667Z"
        fill="#373743"
      />
    </g>
  </svg>
);

export default LogoutIcon;
